import { Injectable, OnDestroy } from '@angular/core';
import { HeaderFooterMachCore } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { ALERT } from '@com-delta-idp/mnx-sitewide-shared-utils';
import { Subject, of } from 'rxjs';
import { catchError, take, takeUntil } from 'rxjs/operators';
import { AlertAdvisoriesFacadeHelper } from './alert-advisories-helper.facade';

@Injectable({
  providedIn: 'root'
})
export class AlertAdvisoriesFacade
  extends AlertAdvisoriesFacadeHelper
  implements OnDestroy
{
  private destroy$ = new Subject<void>();
  init(): void {
    this.headerFooterCall();
  }

  headerFooterCall(): void {
    if (!this.appConfig.onBrowser || !this.contentService.appConfigService) {
      return;
    }

    this.contentService
      .getHeaderFooterMachCoreContent$()
      .pipe(
        take(1),
        catchError((err) => {
          this.loggingService.log(`${ALERT.CAUGHT_ERROR}${err}`);
          return of(null);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => this.processHeaderFooterData(data));
  }

  processHeaderFooterData(data: HeaderFooterMachCore | null): void {
    if (!data) {
      return;
    }

    try {
      this.contentAlertAdvisories = data.applicationadvisories;
      this.darkSiteThemeContent = data.darkSite;
      this.flyoutLangSelectorLink = data.header?.flyoutLanguageSelectorLinkLabel
        ? data.header.flyoutLanguageSelectorLinkLabel
        : 'Select other Location and Language';

      this.processApplicationAdvisories();
      this.checkAdvisoryMatch(); // Using the original method name for compatibility
      this.setAlertAdvisoriesContent(data);
    } catch (error) {
      this.loggingService.log(`${ALERT.CAUGHT_ERROR}${error}`);
    }
  }

  processApplicationAdvisories(): void {
    if (!this.contentAlertAdvisories?.ApplicationAdvisoriesList?.length) {
      return;
    }

    this.checkNumberOfAdvisories(
      this.contentAlertAdvisories.ApplicationAdvisoriesList
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
